import { h, render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IconClose } from 'utils/icon';
import Image from 'utils/image';
import Panel from 'utils/panel';
import fetchProduct from 'utils/fetch-product';
import ProductForm from '../product/product-form';
import NotifyMe from '../product/notify-me';

export default (element, data) => {
  const QuickAdd = () => {
    const { chartPopup, layout } = data;
    const [initialProduct, setInitialProduct] = useState(null);
    const [product, setProduct] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [currentVariant, setCurrentVariant] = useState(null);
    const openPanelEvent = new CustomEvent('quick-add:open');
    const closePanelEvent = new CustomEvent('quick-add:close');
    const [sizeSelected, setSizeSelected] = useState(false);
    const [isDesktop, setIsDesktop] = useState(layout.isAboveBreakpoint('lg'));
    const [addToCartAttributeName, setAddToCartAttributeName] = useState(null);
    const handleBpChange = () => {
      setIsDesktop(layout.isAboveBreakpoint('lg'));
    };

    const handleAddToCartComplete = () => {
      document.dispatchEvent(closePanelEvent);
    };

    useEffect(() => {
      const handleQuickAddOpen = async (event) => {
        const { product: fetchedProduct } = await fetchProduct(
          event.detail.product,
        );
        if (!fetchedProduct) return;
        const { location } = event.detail;
        setProduct(fetchedProduct);
        setAddToCartAttributeName(location);
        if (initialProduct === null) setInitialProduct(fetchedProduct);

        setCurrentVariant(fetchedProduct.variants[0]);
        setTimeout(() => {
          setIsVisible(true);
          document.dispatchEvent(openPanelEvent);
        }, 200);
      };

      window.addEventListener('bpChange', handleBpChange);
      window.addEventListener('openQuickAdd', handleQuickAddOpen);
      document.addEventListener('cart:add-complete', handleAddToCartComplete);

      return () => {
        window.removeEventListener('bpChange', handleBpChange);
        window.removeEventListener('openQuickAdd', handleQuickAddOpen);
        document.removeEventListener(
          'cart:add-complete',
          handleAddToCartComplete,
        );
      };
    }, []);

    if (!product) return null;

    const availableColorsArray = initialProduct?.availableColors?.value
      ? JSON.parse(initialProduct?.availableColors?.value)
      : [];
    const currentColor = initialProduct.variants[0].selectedOptions
      .find((option) => option.name === 'Color')
      ?.value.toLowerCase();

    if (currentColor && availableColorsArray.length > 0) {
      // Put the currentColor object entry first in the array
      const currentColorIndex = availableColorsArray.findIndex(
        (color) => Object.keys(color)[0] === currentColor,
      );
      availableColorsArray.unshift(
        availableColorsArray.splice(currentColorIndex, 1)[0],
      );
    }

    return (
      <Panel
        overlay={!isDesktop}
        context="quick-add"
        alignment={isDesktop ? 'right' : 'bottom'}
        hideHeader={!isDesktop}
        bodyScrollLock={true}
        classes={'max-h-none h-full max-w-none lg:max-w-[500px]'}
      >
        <div className="h-full">
          <div className="flex items-center justify-between px-5 py-4">
            <h3>{window.TMW.Strings.quickAdd.heading}</h3>
            <button onClick={() => document.dispatchEvent(closePanelEvent)}>
              <IconClose />
            </button>
          </div>
          {isVisible && (
            <div className="h-[calc(100%-58px)] overflow-y-scroll no-scrollbar pb-5">
              <Swiper
                allowTouchMove={true}
                spaceBetween={6}
                slidesPerView={2.6}
              >
                {(product.images?.edges || product.images)?.map(
                  (img, index) => (
                    <SwiperSlide
                      key={`${product.id}-${index}`}
                      className="aspect-[140/211]"
                    >
                      <Image
                        {...(img?.node || img)}
                        srcWidths={{
                          sm: 640,
                        }}
                        classes={`relative z-1 object-cover h-full w-full`}
                      />
                    </SwiperSlide>
                  ),
                )}
              </Swiper>
              <div className="px-5">
                <ProductForm
                  product={product}
                  activeProduct={product}
                  hideBreadCrumbs={false}
                  setActiveProduct={setProduct}
                  setCurrentVariant={setCurrentVariant}
                  availableColorsArray={availableColorsArray || []}
                  currentVariant={currentVariant}
                  showDetailsButton={true}
                  chartPopup={chartPopup}
                  isNotPdp={true}
                  colorLimit={8}
                  addToCartAttributeName={addToCartAttributeName}
                  sizeSelected={sizeSelected}
                  setSizeSelected={setSizeSelected}
                  settings={{
                    yotpoApiKey: data.yotpoApiKey,
                  }}
                />

                {(sizeSelected && !currentVariant.availableForSale) ||
                Boolean(product.hideAddToCart) ? (
                  <NotifyMe
                    activeVariant={product}
                    classes={'bg-gray-0 w-full'}
                    product={product}
                  />
                ) : null}
              </div>
            </div>
          )}
        </div>
      </Panel>
    );
  };

  render(<QuickAdd />, element);
};
